import { Component } from "react";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";


import "swiper/css";
import "swiper/css/pagination";

import Rating from "./rating";

const subtitle = "our recent news";
const title = "Check out our posts on X";

const TestimonialListContent = [
  {
    imgUrl: "assets/images/testimonial/user.png",
    imgAlt: "F9 racer photo",
    imgIconUrl: "assets/images/testimonial/logo/x.png",
    imgIconAlt: "X logo",
    title: "Nexus",
    desc: "New personal best on Valley Downhill. 0.13s shaved off! 🏎💨 Team F9 rising every run. #Trackmania #FullSend",
    dige: "@NexusF9",
    ratingcount: "5.0",
  },
  {
    imgUrl: "assets/images/testimonial/user.png",
    imgAlt: "F9 racer photo",
    imgIconUrl: "assets/images/testimonial/logo/x.png",
    imgIconAlt: "X logo",
    title: "Pulse",
    desc: "Grinding the ice maps today. If I slide off the track again, it’s 100% intentional. 🧊😂 #Furious9 #Trackmania",
    dige: "@Pulse9TM",
    ratingcount: "5.3",
  },
  {
    imgUrl: "assets/images/testimonial/user.png",
    imgAlt: "F9 racer photo",
    imgIconUrl: "assets/images/testimonial/logo/x.png",
    imgIconAlt: "X logo",
    title: "Volt",
    desc: "Speed is nothing without control. F9 aiming for clean lines this season. Zero drift. Zero mistakes. ⚡🏁 #CleanDrive",
    dige: "@VoltTM",
    ratingcount: "5.8",
  },
  {
    imgUrl: "assets/images/testimonial/user.png",
    imgAlt: "F9 racer photo",
    imgIconUrl: "assets/images/testimonial/logo/x.png",
    imgIconAlt: "X logo",
    title: "Rift",
    desc: "Massive respect to the squad. Every run, every retry — we race to beat ourselves first. 💙🏎️ #F9TeamSpirit",
    dige: "@RiftF9",
    ratingcount: "5.6",
  },
];

class TestimonialSection extends Component {
  render() {
    return (
      <div className="testimonial-section padding-top ">
        <div className="bg-grain" />
        <div className="container">
          {/* SECTION HEADER */}
          <div className="section-header">
            <p className="text-anim-fade-down js-animate delay-sm">
              {subtitle}
            </p>
            <h2 className="text-anim-typing js-animate delay-md">
              {title}
            </h2>
          </div>

          {/* SLIDER */}
          <div className="section-wrapper">
            <div className="testimonial-slider overflow-hidden">


                <Swiper
                modules={[Autoplay, Pagination]}
                slidesPerView={1.6}
                centeredSlides
                spaceBetween={0}
                loop
                speed={800}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                breakpoints={{
                    0: {
                    slidesPerView: 1.1,
                    },
                    768: {
                    slidesPerView: 1.4,
                    },
                    1200: {
                    slidesPerView: 1.8,
                    },
                }}
                className="testimonial-swiper"
                >


                {TestimonialListContent.map((val, i) => (
                  <SwiperSlide key={i}>
                    <div className="testimonial-item">
                      <div className="testimonial-inner">
                        {/* HEADER */}
                        <div className="testimonial-head">
                          <div className="testi-top">
                            <div className="testimonial-thumb">
                              <img
                                src={val.imgUrl}
                                alt={val.imgAlt}
                              />
                            </div>

                            <div className="name-des">
                              <h5>{val.title}</h5>
                              <p>{val.dige}</p>
                            </div>
                          </div>

                          {/* X ICON */}
                          <img
                            src={val.imgIconUrl}
                            alt={val.imgIconAlt}
                            style={{
                              width: "42px",
                              opacity: 0.85,
                            }}
                          />
                        </div>

                        {/* BODY */}
                        <div className="testimonial-body">
                          <p>{val.desc}</p>
                        </div>

                        {/* OPTIONAL RATING */}
                        {/* <Rating value={val.ratingcount} /> */}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TestimonialSection;
